<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <ViewOrderDetails
                    :orderID="orderID"
                    :backRouteName="backRouteName"
                ></ViewOrderDetails>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ViewOrderDetails from "./ViewOrderDetails.vue";

export default {
    components: {
        ViewOrderDetails
    },
    props: [
        'orderID',
        'backRouteName'
    ],
    data() {
        return {

        };
    },
    computed: {
        
    },
    methods: {

    },
    created(){

    }
};
</script>

<style>
    
</style>